import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=cab6de56&"
import script from "./Talent.vue?vue&type=script&lang=js&"
export * from "./Talent.vue?vue&type=script&lang=js&"
import style0 from "./Talent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports